import React, { useEffect, useRef, useState } from "react"
import { Box, Container, Heading, Image, Text } from "theme-ui"
import RichContentStructuredText from "../richContentStructuredText"
import { BsChevronLeft, BsChevronRight } from "react-icons/bs"
import { i18nContext } from "../../context/i18nContext"
import { InboundLink } from "../link"
import { getPagePath } from "../../utils/path"
import { GatsbyImage } from "gatsby-plugin-image"

const ModulesSection = ({ block }) => {
  const [active, setActive] = useState("rotate(0deg)")
  const [activeIndex, setActiveIndex] = useState(0)
  const [changeCount, setChangeCount] = useState(0)
  const intervalRef = useRef(null)
  const { modules, image } = block

  useEffect(() => {
    setActive(`rotate(${(360 / modules.length) * (changeCount * -1)}deg)`)
  }, [changeCount])

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      // console.log("SET INTERVAL", activeIndex)
      setChangeCount(changeCount => changeCount + 1)
      setActiveIndex(activeIndex =>
        activeIndex < modules.length - 1 ? activeIndex + 1 : 0
      )
    }, 2000)
    return () => clearInterval(intervalRef.current)
  }, [])

  return (
    <i18nContext.Consumer>
      {t => (
        <Box sx={{ position: "relative" }}>
          {image && (
            <Box
              sx={{
                position: ["absolute"],
                width: ["100%", "100%", "100%"],
                height: "100%",
                top: 0,
                left: 0,
                ".gatsby-image-wrapper": {
                  height: "100%",
                  width: "100%",
                },
              }}
            >
              <GatsbyImage image={image.gatsbyImageData} alt="" />
            </Box>
          )}
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              display: "block",
              backgroundColor: "primary",
              pt: [6, 7],
              pb: [6, 10],
              ".prev-container,.next-container": {
                position: "absolute",
                top: "0",
                bottom: "0",
                display: ["none", "flex"],
                justifyContent: "center",
                alignItems: "center",
                width: "calc((100vw - 100vh) / 2)",
                minWidth: "12.5vw",
                ".prev,.next": {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  width: "40px",
                  cursor: "pointer",
                  textAlign: "center",
                  color: "white",
                  borderRadius: "50%",
                  border: "1px solid white",
                  transition: "color 0.3s, background-color 0.3s",
                  "&:hover": { color: "#0066AC", background: "white" },
                },
              },
              ".prev-container": { right: "100%" },
              ".next-container": { left: "100%" },
            }}
          >
            <Container sx={{ py: [0, 0, 0] }}>
              <Heading
                as="h2"
                variant="h1"
                sx={{
                  color: "light",
                  fontWeight: "400",
                  fontSize: [5, 6, 6],
                  mt: [0, 0, 0],
                  mb: [7],
                }}
              >
                {t.modules}
              </Heading>
            </Container>
            <Box
              className="circle--slider"
              sx={{
                position: "relative",
              }}
            >
              <Box
                className="rotate--circle"
                sx={{
                  margin: "0 auto",
                  position: "relative",
                  zIndex: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: ["75vw", "50vw"],
                  height: ["75vw", "50vw"],
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255,.1)",
                  backgroundImage:
                    "url('../../assets/images/process-outer-circle.svg')",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  "&::before": {
                    content: "''",
                    position: "absolute",
                    zIndex: 2,
                    left: "10%",
                    top: "10%",
                    width: "80%",
                    height: "80%",
                    borderRadius: "50%",
                    background: "#004A7D",
                  },
                  ".co2-icon": {
                    position: "absolute",
                    zIndex: 2,
                    left: "50%",
                    top: "5%",
                    display: "block",
                    width: "72px",
                    height: "72px",
                    transform: "translate(-50%,-50%)",
                    img: { display: "block", width: "100%", height: "auto" },
                  },
                }}
              >
                <Box
                  as="ul"
                  className="circle--rotate count8"
                  id="circle--rotate"
                  sx={{
                    transform: active,
                    transition: "all .3s",
                    position: "relative",
                    zIndex: 2,
                    borderRadius: "50%",
                    border: "1px solid white",
                    width: ["75vw", "40vw"],
                    maxWidth: "67.5vw",
                    height: ["75vw", "40vw"],
                    maxHeight: "67.5vw",
                    margin: "0 auto 0",
                    padding: "0",
                  }}
                >
                  {modules.map((module, index) => (
                    <Box
                      as="li"
                      className={`block ${index === activeIndex && "active"}`}
                      sx={{
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%",
                        display: "block",
                        borderRadius: "50%",
                        zIndex: 10,
                        ".icon": {
                          display: "block",
                          margin: "-20px auto",
                          cursor: "pointer",
                          color: "#0066AC",
                          borderRadius: "50%",
                          border: "1px solid white",
                          background: "#004A7D",
                          visibility: "visible",
                          transition: "all 0.3s ease-out",
                          width: ["40px", "56px", "72px"],
                          height: ["40px", "56px", "72px"],
                          margin: ["-20px auto", "-28px auto", "-36px auto"],
                          "&:hover": {
                            color: "white",
                            backgroundColor: "light",
                            boxShadow:
                              "0px 0px 15px 5px rgba(255, 255, 255, .25)",
                          },
                        },
                        "&.active": {
                          ".icon": {
                            // color: "white",
                            border: "1px solid light",
                            backgroundColor: "light",
                            width: ["40px", "56px", "84px"],
                            height: ["40px", "56px", "84px"],
                            overflow: "hidden",
                            img: { maxWidth: ["28px", "48px"] },
                            boxShadow:
                              "0px 0px 15px 5px rgba(255, 255, 255, .25)",
                          },
                        },
                        transform:
                          index !== 0
                            ? index < modules.length / 2
                              ? `rotate(${(360 / modules.length) * index}deg)`
                              : `rotate(-${
                                  (360 / modules.length) *
                                  (modules.length - index)
                                }deg)`
                            : null,
                      }}
                      onClick={event => {
                        if (
                          event.target.classList.contains("icon") ||
                          event.target.classList.contains("icon-image")
                        ) {
                          clearInterval(intervalRef.current)
                          setChangeCount(
                            index > activeIndex
                              ? changeCount + (index - activeIndex)
                              : changeCount - (activeIndex - index)
                          )
                          setActiveIndex(index)
                          return
                        }
                        event.stopPropagation()
                      }}
                    >
                      <Box
                        className={`icon`}
                        sx={{
                          display: "flex!important",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "light",
                          overflow: "hidden",
                          img: { maxWidth: ["24px", "36px"] },
                        }}
                      >
                        <Image className="icon-image" src={module.icon.url} />
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Box
                  className="animate-wrapper"
                  sx={{
                    position: "absolute",
                    zIndex: 3,
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    width: ["60vw", "30.25vw"],
                    maxWidth: "55vw",
                    height: ["60vw", "30.25vw"],
                    maxHeight: "55vw",
                    margin: "auto",
                    borderRadius: "50%",
                    background: "#0066AC",
                  }}
                >
                  {modules.map((module, index) => (
                    <InboundLink
                      to={getPagePath(module, module.locale)}
                      style={{
                        width: "80%",
                        height: "80%",
                        zIndex: 5,
                        borderRadius: "1000px",
                        backgroundColor: "dark",
                        transform: "translate(12.5%, 12.5%)",
                        // position: "relative",
                        display: activeIndex === index ? "block" : "none",
                      }}
                    >
                      <Box
                        className={`animate ${
                          activeIndex === index ? "active" : null
                        }`}
                        sx={{
                          "&.active": {
                            ".animate-more": {
                              opacity: 1,
                              visibility: "visible",
                              transform: "translateY(0)",
                              transition: "all .3s .4s",
                            },
                            ".animate-img  .animate-img__in": { opacity: 1 },
                          },
                        }}
                      >
                        <Box
                          className="animate-img"
                          sx={{
                            width: "25%",
                            height: "25%",
                            borderRadius: "50%",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            className="animate-img__in"
                            sx={{
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              left: "0",
                              right: "0",
                              margin: "auto",
                              borderRadius: "50%",
                              zIndex: 3,
                              width: "100%",
                              height: "100%",
                              opacity: 0,
                              transition: ".55s ease-in-out",
                            }}
                          >
                            <Box
                              className="animate-more"
                              sx={{
                                zIndex: 30,
                                position: "absolute",
                                top: "0",
                                left: "0",
                                right: "0",
                                bottom: "0",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                margin: "auto",
                                padding: "10% 10% 15% 10%",
                                textAlign: "center",
                                transform: "translateY(20px)",
                                opacity: 0,
                                visibility: "hidden",
                                transition: "all .3s",
                              }}
                            >
                              <Text
                                as="h2"
                                variant="h4"
                                sx={{
                                  mb: [0],
                                  mt: [2, 4],
                                  fontSize: [2, 3, 5, 6],
                                  color: "light",
                                  fontWeight: "700",
                                  textTransform: "uppercase",
                                }}
                              >
                                {module.title}
                              </Text>
                              <Box
                                sx={{
                                  pt: [2],
                                  pb: [0],
                                  maxWidth: ["80%", "70%"],
                                  p: {
                                    fontSize: ["13px", 2, 2, 3],
                                    color: "light",
                                    display: ["none", "none", "block"],
                                  },
                                  h2: {
                                    fontWeight: [300],
                                    fontSize: [2, 2, 3, 4],
                                    color: "light",
                                    display: ["block", "block", "none"],
                                  },
                                }}
                              >
                                <RichContentStructuredText
                                  text={module.shortDescription}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </InboundLink>
                  ))}
                </Box>
                <Box className="prev-container">
                  <Box
                    className="prev"
                    onClick={() => {
                      clearInterval(intervalRef.current)
                      setActiveIndex(
                        activeIndex === 0 ? modules.length - 1 : activeIndex - 1
                      )
                      setChangeCount(changeCount - 1)
                    }}
                  >
                    <Box
                      as="spam"
                      className="material-icons"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <BsChevronLeft size={24} />
                    </Box>
                  </Box>
                </Box>
                <Box className="next-container">
                  <Box
                    className="next"
                    onClick={() => {
                      clearInterval(intervalRef.current)
                      setActiveIndex(
                        activeIndex + 1 >= modules.length ? 0 : activeIndex + 1
                      )
                      setChangeCount(changeCount + 1)
                    }}
                  >
                    <Box
                      as="spam"
                      className="material-icons"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <BsChevronRight size={24} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

export default ModulesSection
